import { createSelector } from '@reduxjs/toolkit';

import { getName } from '@/shared/lib';
import { getImageSrc } from '@/shared/lib';

import { organizationModel } from '@/entities/organization';
import { userModel } from '@/entities/user';

import { isTreatingDoctor } from '../lib/isTreatingDoctor';

export const selectOrganizationDoctorsOptions = createSelector(
  organizationModel.selectors.selectTreatingDoctors,
  userModel.selectors.selectCurrentUser,
  userModel.selectors.selectUserLocale,
  (organizationDoctorsAsUserRole = [], user, userLocale) => {
    const currentUserAsDoctor = organizationDoctorsAsUserRole.find(
      (doctor) => doctor.UserID === user.ID,
    );

    const isCurrentUserTreatingDoctor = isTreatingDoctor(
      currentUserAsDoctor?.Role,
    );

    if (isCurrentUserTreatingDoctor) {
      const avatarSrc = getImageSrc(
        currentUserAsDoctor?.AvatarAssetID,
        'thumbnail',
      );
      const doctorName = getName(
        currentUserAsDoctor?.PersonalData?.FirstName,
        currentUserAsDoctor?.PersonalData?.LastName,
        {
          userLocale,
        },
      );

      return [
        {
          label: doctorName,
          value: currentUserAsDoctor?.ID as string,
          userID: currentUserAsDoctor?.UserID as string,
          avatarSrc,
        },
      ];
    }

    return organizationDoctorsAsUserRole.map((doctor) => {
      const avatarSrc = getImageSrc(doctor?.AvatarAssetID, 'thumbnail');
      const doctorName = getName(
        doctor?.PersonalData?.FirstName,
        doctor?.PersonalData?.LastName,
        {
          userLocale,
        },
      );

      return {
        label: doctorName,
        value: doctor?.ID ?? '',
        userID: doctor?.UserID ?? '',
        avatarSrc,
      };
    });
  },
);
